import {
  AppUpdateProvider,
  useAppUpdate,
  type UpdateCheckResult,
} from "@shared/lib/useAppUpdate";

export const PWAProvider = AppUpdateProvider;

type PWAContextValue = {
  needRefresh: boolean;
  isUpdating: boolean;
  isChecking: boolean;
  applyUpdate: () => void;
  dismissUpdatePrompt: () => void;
  checkForUpdate: () => Promise<UpdateCheckResult>;
};

export function usePWA(): PWAContextValue {
  const {
    needRefresh,
    isUpdating,
    isChecking,
    applyUpdate,
    dismissUpdate,
    checkForUpdate,
  } = useAppUpdate();

  return {
    needRefresh,
    isUpdating,
    isChecking,
    applyUpdate,
    dismissUpdatePrompt: dismissUpdate,
    checkForUpdate,
  };
}
